export default "__VITE_ASSET__Cw__qjTU__"